import { Const } from '../scripts/Const'

//#region 駅探定期経路検索　パラメータ
/** 駅探定期経路検索　パラメータ */
export class TrainPassRouteSearchCondition {

    /** 乗車駅コード */
    public startStationCd: string = '';
    /** 下車駅コード */
    public endStationCd: string = '';
    /**　経由駅コード */
    public transitStationCd: string = '';
    /**　検索対象日 */
    public targetDate: string = '';
    /** 　検索対象時刻（出発時刻）*/
    public targetTime: string = '0900';
}
//#endregion

//#region 駅探交通費検索　パラメータ
/** 駅探交通費検索　パラメータ */
export class CostRouteSearchCondition {

    /** 乗車駅コード */
    public startStationCd: string = '';
    /** 下車駅コード */
    public endStationCd: string = '';
    /**　経由駅コード */
    public transitStationCd: string = '';
    /**　検索対象日 */
    public targetDate: string = '';
    /** 　検索対象時刻（出発時刻）*/
    public targetTime: string = '0900';
    /** 検索順 */
    public orderKbn: string = Const.TransPortCost.orderKbn.AMOUNT;
    /**　片道・往復区分 */
    public roundKbn: string = Const.TransPortCost.roundKbn.ONE_WAY;
    /** 区間コード1 */
    public passKey1: string = '';
    /** 区間コード2 */
    public passKey2: string = '';
    /** 区間コード3 */
    public passKey3: string = '';
    /** 定期購入フラグ */
    public trainPassPurchaseFlg: boolean = true;
    /** 経路区分 */
    public commuteRouteKbn: string = '';

}
//#endregion